import React, { useState, useEffect } from 'react';
import '../../../../style/Arrears/ArrearsSeventhResult.css';
import { useParams } from 'react-router-dom';
import {PDFDownloadButton} from './PDFUIWrapper';
import {PDFViewButton} from './PDFUIWrapper';
import InteractiveExcelWrapper  from './xlsxUIwrapper';
import { sendEmail } from './ArrearsSeventhEmail';
// import { CallMailDetails } from './ArrearsSeventhEmail';
import LoadingPage from '../../../Loader';
import SubmissionConfirmation from '../../../pages/dataSubmit/dataSubmitted';
import ErrorPage from '../../../pages/dataSubmit/404PageNotFound';


const ArrearsSeventhResult = () => {
  const { uniqueFormId } = useParams(); 
  const [result, setResult] = useState([]);
  const [info, setInfo] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [httpStatus, setHttpStatus] = useState(null);
  const [timestamp, setTimestamp] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [emailSent, setEmailSent] = useState(false);
  const rowsPerPage = 24;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/arrearesSeventh/arrears_seventh_result/${uniqueFormId}`);
        setHttpStatus(response.status);

        if (response.status === 403) {
        const data = await response.json();
        setTimestamp(data.timestamp); 
        return; 
      }

        if (!response.ok) {
          throw new Error("Unable to fetch data");
        }
        
        const data = await response.json();
         
         // Format the info object and then set it
         const formattedInfo = {
           ...data.info,
           arrearsEndDate: new Date(data.info.arrearsEndDate).toLocaleDateString('en-GB', {
             day: '2-digit',
             month: '2-digit',
             year: 'numeric',
           }),
         };
               
               setInfo(formattedInfo);  // Only call setInfo once
               setResult(Array.isArray(data.result) ? data.result : []);  // Update result
         
                // Send email only if it hasn't been sent yet
                if (!emailSent) {
                  await sendEmail(data.result, formattedInfo); 
                 setEmailSent(true);
               }
       
             } catch (err) {
               setError(err.message);
             } finally {
               setLoading(false);
             }
           };
         
           fetchData();
  }, [uniqueFormId, emailSent]); 

  if (loading) {
    return <LoadingPage />;
  }
// Render SubmissionConfirmation only for 403
if (httpStatus === 403) {
  return (
    <SubmissionConfirmation
      uniqueFormId={uniqueFormId}
      timestamp={timestamp}
    />
  );
}
// Return nothing (blank page) for 404
if (httpStatus === 404) {
  return <ErrorPage/>;
}

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = result.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(result.length / rowsPerPage);

  return (
    <div className="legal-page">
      <header>
        <label>Arrears Calculation Results</label>
        Date: {`${String(new Date().getDate()).padStart(2, '0')}/${String(new Date().getMonth() + 1).padStart(2, '0')}/${new Date().getFullYear()}`}
      </header>

      <main>
  <div className="legal-table-container">
    <div className="employee-info">
    <div >
      <label>{info.employeeName}</label>
      <l1>DESIGNATION: {info.designation}</l1>
    </div>

    <label>{info.officeName}</label>
    <p>Statement showing the difference of Pay & Allowances payable due to ACP for the period {info.arrearsStartDate} to {info.arrearsEndDate}</p>
    </div>
    {/* Salary Section Header */}
    <table className="legal-table">
      <thead>
        <tr className="salary-header">
          <th colSpan="2"></th>
          <th colSpan="8">DUE SALARY</th>
          <th colSpan="8">DRAWN SALARY</th>
          <th colSpan="7">DIFFERENCE</th>
          <th colSpan="3">PROF. TAX</th>
          <th colSpan="1"></th>
        </tr>
        <tr>
          <th>Sr.No.</th>
          <th>Month</th>
          <th>Basic Pay</th>
          <th>%DA</th>
          <th>DA</th>
          <th>CLA</th>
          <th>HRA</th>
          <th>TRA</th>
          <th>Spl</th>
          <th>Total</th>
          <th>Basic Pay</th>
          <th>%DA</th>
          <th>DA</th>
          <th>CLA</th>
          <th>HRA</th>
          <th>TRA</th>
          <th>Spl</th>
          <th>Total</th>
          <th>Basic Pay</th>
          <th>DA</th>
          <th>CLA</th>
          <th>HRA</th>
          <th>TRA</th>
          <th>Spl</th>
          <th>Total</th>
          <th>PT</th>
          <th>PT</th>
          <th>PTRec</th>
          <th>Net</th>
        </tr>
        <tr>
          <th>1</th>
          {Array.from({ length: 28 }, (_, i) => (
            <th key={i}>{i + 2}</th>
          ))}
        </tr>
        <tr>
        </tr>
      </thead>
      <tbody>
     
        {currentRows.length > 0 ? (
          currentRows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              <td>{indexOfFirstRow + rowIndex + 1}</td>
              {row.map((cell, cellIndex) => (
                <td key={cellIndex}>{cell}</td>
              ))}
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="29">No data available</td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
</main>

        
      <pagenav>
        <div className="page-nav">

          <button onClick={() => setCurrentPage(Math.max(currentPage - 1, 1))}>Previous</button>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">
  {/* PDF Section */}
  <div className="bg-white p-5 rounded-xl border border-gray-200 shadow-sm w-full">
    <div className="flex items-center mb-4">
      <div className="p-2 bg-blue-100 rounded-md mr-3">
        <span className="text-blue-600 font-semibold text-sm">PDF</span>
      </div>
      <h4 className="text-base font-medium text-gray-800">Download PDF</h4>
    </div>
    <div className="flex flex-wrap gap-3">
      <div className="w-36">
        <PDFDownloadButton result={result} info={info} />
      </div>
      <div className="w-50">
        <PDFViewButton result={result} info={info} />
      </div>
    </div>
  </div>

  {/* Excel Section */}
  <div className="bg-white p-5 rounded-xl border border-gray-200 shadow-sm w-full">
    <div className="flex items-center mb-4">
      <div className="p-2 bg-green-100 rounded-md mr-3">
        <span className="text-green-600 font-semibold text-sm">Excel</span>
      </div>
      <h4 className="text-base font-medium text-gray-800">Download Excel</h4>
    </div>
    <div className="flex flex-wrap gap-3">
      <div className="w-36">
        <InteractiveExcelWrapper result={result} info={info} />
      </div>
    </div>
  </div>
</div>

          <button onClick={() => setCurrentPage(Math.min(currentPage + 1, totalPages))}>Next</button>
        </div>
        <p>Page {currentPage} of {totalPages}</p> 

      </pagenav>
    </div>
  );
};

export default ArrearsSeventhResult;
